module.exports = __webpack_public_path__ + "img/signing-a-document.3c4f110b.svg";